module.exports = __webpack_public_path__ + "img/header-memoireRings.57e1a42.jpg";